import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ConfigService } from '../../../../../config/config.service';
import { Client } from '../../../../shared/client/client';
import { ActivatedParams, Dotation, Lingerie, LingerieParams, TypeLingerie } from './lingerie';

@Injectable({
  providedIn: 'root'
})
export class LingerieService {


  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public postLingerieClient(idClient: string, lingerieParams: LingerieParams) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<LingerieParams>(
          config.apiPoint + config.postLingerieClient
            .replace("{client}", idClient),
          lingerieParams
        );
      })
    );
  }

  public getLingeriesClient(idClient: string): Observable<Lingerie[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Lingerie[]>(
          config.apiPoint + config.getLingeriesClient
            .replace("{client}", idClient)
        );
      })
    );
  }

  public updateLingerie(idLingerie: number, lingerieParams: LingerieParams) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.put<LingerieParams>(
          config.apiPoint + config.updateLingerie
            .replace("{lingerie}", idLingerie),
          lingerieParams
        );
      })
    );
  }

  public getDotations(idLingerie: number) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Dotation[]>(
          config.apiPoint + config.getLingerieDotations
            .replace("{lingerie}", idLingerie)
        );
      })
    );
  }

  public getClientTypesLingeries(client: Client): Observable<TypeLingerie[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<TypeLingerie[]>(config.apiPoint + config.getClientTypesLingeries.replace("{client}", client.id));
      })
    );
  }

  public activateLingerieClient(idClient: string, activatedParams: ActivatedParams) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<LingerieParams>(
          config.apiPoint + config.activateLingerieClient
            .replace("{client}", idClient),
          activatedParams
        );
      })
    );
  }

  public getLingeriesClientDeactivated(idClient: string): Observable<Lingerie[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Lingerie[]>(
          config.apiPoint + config.getLingeriesClientDeactivated
            .replace("{client}", idClient)
        );
      })
    );
  }
}
